<template>
  <section class="platform">
    <banner />
    <Enablement />
    <Intelligence />
    <Demand />
    <div class="footer">
      <div class="footer-inner">
        <h2>让世界成为你的市场</h2>
        <div class="button-link">让我们谈谈</div>
      </div>
    </div>
  </section>
</template>

<script>
import banner from './components/banner.vue'
import Enablement from './components/Enablement.vue'
import Intelligence from './components/Intelligence.vue'
import Demand from './components/Demand.vue'
export default {
  name: 'Platform',
  components: {
    banner,
    Enablement,
    Intelligence,
    Demand
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="less">
.platform {
  .footer {
    padding: 0 5%;
    height: 132px;
    background-color: #2a2b2f;
    .footer-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 40px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;
      h2 {
        color: #fff;
        font-size: 36px;
      }
      .button-link {
        width: 172px;
        height: 52px;
        text-align: center;
        line-height: 52px;
        background-color: #2f5ad9;
        border-radius: 26px;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
        &:hover {
          background-color: #fff;
          color: #2f5ad9;
        }
      }
    }
  }
}
</style>
